import { EventLoader, eventLoader } from "@otto-ec/global-event-loader";

window.o_global = window.o_global || {};
window.o_global.EventLoader = EventLoader;
window.o_global.eventLoader = eventLoader();

/**
 * Queue all registered functions to be handled as window.onload event handler.
 * @param {Function} func   Function to be queued to window.onload.
 */
window.o_global.onloadHandler =
  window.o_global.onloadHandler ||
  ((func: EventListener): void => window.o_global.eventLoader.onLoad(100, func));
